import tools from '@/sui/data/sheets/edit/tools'
import ice from '@/sui/tools/ice'
import patient from '@/sui/data/sheets/edit/patient'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'
import clone from 'clone'
import { checkAge, checkDate } from '@/sui/data/sheets/edit/notes/observa4'

import v2020 from '@/sui/data/sheets/edit/observa4/2020'

const result = clone(v2020)

// +++ ADD       obsDate (date)
result.fields.obsDate = {
  all: tools.cfg.date(fields.obsDate, `d'observation`)
}

// +++ ADD       p1otherCatheterType (text)
// +++ ADD       b1otherCatheterType (text)
// +++ ADD       b2otherCatheterType (text)
result.fields.otherCatheterType = (function () {
  const t = 'Préciser le dispositif'
  const f = fields.otherCatheterType

  return {
    p1: tools.cfg.text(
      `p1${f}`, t, { sel: tools.equals(result.fields.catheterType.p1.field, 6), srv: f }
    ),

    b1: tools.cfg.text(
      `b1${f}`, t, { sel: tools.equals(result.fields.catheterType.b1.field, 6), srv: f }
    ),

    b2: tools.cfg.text(
      `b2${f}`, t, { sel: tools.equals(result.fields.catheterType.b2.field, 6), srv: f }
    )
  }
})()

// --- REMOVE    b2sterileGloves (list)
// --- REMOVE    p1sterileGloves (list)
delete result.fields.sterileGloves

// +++ ADD       b2gloves (list)
// +++ ADD       p1p2p3p4b1gloves (list)
// --- REMOVE    gloves (list)
result.fields.gloves = (function () {
  const reference = result.fields.gloves.p2p3b1
  const t = reference.config.title
  const f = reference.field
  const v = reference.config.values

  return {
    b2: tools.cfg.list(`b2${f}`, t, v, { sel: result.select.b2, srv: f }),
    p1p2p3b1: tools.cfg.list(
      `p1p2p3p4b1${f}`, t, v,
      { sel: result.select.p1p2p3p4b1, srv: f }
    )
  }
})()

// +++ ADD       b2glovesType (list)
// +++ ADD       p1p2p3p4b1glovesType (list)
// --- REMOVE    glovesType (list)
result.fields.glovesType = (function () {
  const reference = result.fields.glovesType.p2p3
  const t = reference.config.title
  const f = reference.field
  const v = reference.config.values

  return {
    b2: tools.cfg.list(
      `b2${f}`, t, v, {
        sel: tools.allTrue(
          result.fields.gloves.b2.selectList._list[0],
          result.select.yes(result.fields.gloves.b2.field)
        ),
        srv: f
      }
    ),
    p1p2p3b1: tools.cfg.list(
      `p1p2p3p4b1${f}`, t, v, {
        sel: tools.allTrue(
          result.fields.gloves.p1p2p3b1.selectList._list[0],
          result.select.yes(result.fields.gloves.p1p2p3b1.field)
        ),
        srv: f
      }
    )
  }
})()

//     UPDATE    childAge (list)        childAge>config>values: different sizes
result.fields.childAge.p1p2p3.config.values = go.fields.childAge

// +++ ADD       p1p2p3p4UseCompresses (list)
// +++ ADD       b1b2UseCompresses (list)
result.fields.useCompresses = (function () {
  const t = 'Utilisation de compresses'
  const f = 'UseCompresses'

  return {
    p1p2p3: tools.cfg.list(
      `p1p2p3p4${f}`, t, go.fields.yesNoSo, {
        sel: tools.allTrue(
          result.fields.antiseptic.p1p2p3[0].selectList._list[0],
          result.select.yes(result.fields.antiseptic.p1p2p3[0].field)
        ),
        srv: fields.useCompresses
      }
    ),
    b1b2: tools.cfg.list(
      `b1b2${f}`, t, go.fields.yesNo, {
        sel: result.select.b1b2, srv: fields.useCompresses
      }
    )
  }
})()

// --- REMOVE    p1p2p3SterileCompresses (list)
// --- REMOVE    b1b2SterileCompresses (list)
delete result.fields.sterileCompresses

// +++ ADD       p1p2p3p4CompressesType (list)
// +++ ADD       b1b2CompressesType (list)
result.fields.compressesType = (function () {
  const t = 'Type de compresses'
  const f = 'CompressesType'
  const v = go.fields.compresses

  return {
    p1p2p3: tools.cfg.list(
      `p1p2p3p4${f}`, t, v, {
        sel: tools.allTrue(
          result.fields.useCompresses.p1p2p3.selectList._list[0],
          result.select.yes(result.fields.useCompresses.p1p2p3.field)
        ),
        srv: fields.compressesType
      }
    ),
    b1b2: tools.cfg.list(
      `b1b2${f}`, t, v, {
        sel: tools.allTrue(
          result.fields.useCompresses.b1b2.selectList._list[0],
          result.select.yes(result.fields.useCompresses.b1b2.field)
        ),
        srv: fields.compressesType
      }
    )
  }
})()

//     UPDATE    b1CompressAntisepticApplied (list)b1CompressAntisepticApplied>selectList: different sizes
//     UPDATE    b1CompressAntiseptic (list)b1CompressAntiseptic>selectList: different sizes
//     UPDATE    b1CompressAntisepticOther (text)b1CompressAntisepticOther>selectList: different sizes
for (let i = 0; i !== result.fields.antiseptic.b1.length; ++i) {
  const item = result.fields.antiseptic.b1[i]
  result.fields.antiseptic.b1[i] = tools.andSelect(
    item, result.select.yes(result.fields.useCompresses.b1b2.field)
  )
}

//     UPDATE    b2CompressAntisepticApplied (list)b2CompressAntisepticApplied>selectList: different sizes
//     UPDATE    b2CompressAntiseptic (list)b2CompressAntiseptic>selectList: different sizes
//     UPDATE    b2CompressAntisepticOther (text)b2CompressAntisepticOther>selectList: different sizes
for (let i = 0; i !== result.fields.antiseptic.b2.length; ++i) {
  const item = result.fields.antiseptic.b2[i]
  result.fields.antiseptic.b2[i] = tools.andSelect(
    item, result.select.yes(result.fields.useCompresses.b1b2.field)
  )
}
//     UPDATE    valve (list)           valve>config>title: different values (Présence d'une valve bidirectionnelle / Utilisation d'une valve bidirectionnelle)
result.fields.valve.b1b2.config.title = `Utilisation d'une valve bidirectionnelle`

// +++ ADD       valveAntisepticCompliant (list)
result.fields.valveAntiseptic.b1b2.splice(
  1,
  0,
  tools.cfg.list(
    `${result.fields.valveAntiseptic.b1b2[1].field}Compliant`,
    `La technique de désinfection est-elle conforme ?`,
    go.fields.yesNo,
    { sel: result.select.yes(result.fields.valveAntiseptic.b1b2[0].field) }
  )
)

//     UPDATE    antisepticPassages (numeric)antisepticPassages>type: different values (numeric / list)
result.fields.antisepticPassages.p1p2p3 = tools.cfg.list(
  fields.antisepticPassages, `Nombre de passages de l'antiseptique`,
  go.fields.antisepticPassages, {
    sel: tools.allTrue(
      result.select.p1p2p3p4,
      result.select.yes(result.fields.antiseptic.p1p2p3[0].field)
    ),
    srv: `${fields.antisepticPassages}_v2`
  }
)

//     UPDATE    glovesJustified (list) glovesJustified>selectList>0/0: different function names "allTrue ((obsManagment === 4), (gloves === 1))" "allTrue ((obsManagment === 4), (p1p2p3p4b1gloves === 1))}"
result.fields.glovesJustified.b1 = tools.select(
  result.fields.glovesJustified.b1,
  tools.allTrue(
    result.select.b1,
    result.select.yes(result.fields.gloves.p1p2p3b1.field)
  )
)

//     UPDATE    whyNotAlcool (list)    whyNotAlcool>selectList>0/0: different function names "allTrue (oneTrue (allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3)), (isAdult === 1)), allTrue ((obsManagment === 6), (unitTypeMatch /^AD/))), ([1,4,6,9].indexOf(p1p2p3p4Antiseptic) !== -1 || (p1p2p3p4Antiseptic === 10 && Other.match(/alcoolique/i)))" "allTrue (oneTrue (allTrue (oneTrue ((obsManagment === 1), (obsManagment === 2), (obsManagment === 3)), (isAdult === 1)), allTrue ((obsManagment === 6), (unitTypeMatch /^AD/))), ([1,3,4,6,9].indexOf(p1p2p3p4Antiseptic) !== -1 || (p1p2p3p4Antiseptic === 10 && Other.match(/alcoolique/i)))}"
result.fields.whyNotAlcool.p1p2p3 = result.build.notAlcool(
  '', [1, 3, 4, 6, 9], tools.oneTrue(
    tools.allTrue(
      result.select.p1p2p3, result.select.yes(result.fields.isAdult.p1p2p3.field)
    ),
    tools.allTrue(result.select.p4, patient.select.isAd)
  ),
  'p1p2p3p4'
)

//     UPDATE    whyNotGloves (list)    whyNotGloves>selectList>0/0: different function names "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 6)), (gloves === 2))" "allTrue (oneTrue ((obsManagment === 2), (obsManagment === 6)), (p1p2p3p4b1gloves === 2))}"
result.fields.whyNotGloves.p2[0] = tools.select(
  result.fields.whyNotGloves.p2[0],
  tools.allTrue(
    result.select.p2p4,
    result.select.no(result.fields.gloves.p1p2p3b1.field)
  )
)

// +++ ADD       whyNotCompresses (list)
// +++ ADD       whyNotCompressesDetail (text)
result.fields.whyNotCompresses = {
  b1: result.build.why(
    '', fields.whyNotCompresses,
    `Pourquoi l'audité n'utilise-t-il pas de compresses pour la manipulation ?`,
    tools.allTrue(
      result.select.b1,
      result.select.no(
        result.fields.useCompresses.b1b2.field
      )
    ),
    go.fields.whyNotCompresses,
    null, null, '_v2'
  )
}
//     UPDATE    whyNotSterileCompresses (list)whyNotSterileCompresses>config>title: different values (Pourquoi des compresses stériles n'ont-elles pas été utilisées ? / Pourquoi les compresses utilisées pour la désinfection ne sont pas stériles ?)
//     UPDATE    whyNotSterileCompresses (list)whyNotSterileCompresses>config>values>1>value: different values (2. Trop coûteux / 2. Oubli)
//     UPDATE    whyNotSterileCompresses (list)whyNotSterileCompresses>selectList>0/0: different function names "allTrue ((obsManagment === 4), (b1b2SterileCompresses === 2))" "allTrue ((obsManagment === 4), (b1b2CompressesType === 1))}"
result.fields.whyNotSterileCompresses.b1 = result.build.why(
  '', fields.whyNotSterileCompresses,
  `Pourquoi les compresses utilisées pour la désinfection ne sont pas stériles ?`,
  tools.allTrue(
    result.select.b1,
    tools.equals(result.fields.compressesType.b1b2.field, 1)
  ),
  go.fields.whyNotSterileCompresses
)

result.sheet = {
  titles: result.sheet.titles,

  fields: [
    result.fields.obsManagment.all,
    ...tools.addSelect(result.select.obs, [
      patient.sheetNumber.v2,
      result.fields.obsDate.all,
      tools.opts(patient.unitType.v1.rw, { sp: 'unitType' }),
      patient.uf
    ]),

    result.fields.place.p1,
    result.fields.otherPlace.p1,
    result.fields.catheterType.p1,
    result.fields.catheterType.p2,
    result.fields.catheterType.b1,
    result.fields.catheterType.b2,
    result.fields.otherCatheterType.p1,
    result.fields.otherCatheterType.b1,
    result.fields.otherCatheterType.b2,
    result.fields.audited.p1p3,
    result.fields.audited.p2b1b2,
    result.fields.student.all,
    result.fields.auditedCleanOutfit.p2p3b1b2,
    result.fields.sterileGown.p1,
    result.fields.auditedCap.p1p3,
    result.fields.compliantAuditedCap.p1p3,
    result.fields.gloves.b2,
    result.fields.glovesType.b2,
    result.fields.auditedMask.p1p3b2,
    result.fields.compliantAuditedMask.p1p3b2,
    result.fields.isAdult.p1p2p3,
    result.fields.childAge.p1p2p3,
    result.fields.patientCleanOutfit.p1p2p3b2,
    result.fields.patientMask.p1p3b2,
    result.fields.compliantPatientMask.p1p3b2,
    result.fields.patientSterileField.p1,
    result.fields.patientOtherSide.p3b2,
    result.fields.patientCap.p1,
    result.fields.compliantPatientCap.p1,

    ...result.fields.handHygieneBeforePreparation.p2p3,
    ...result.fields.handHygieneBeforeManip.b1,
    ...result.fields.handHygieneBeforeGloves.b2,

    result.fields.dirtySkin.p1p2p3,
    result.fields.insertionSiteCleaned.p1p2p3,
    ...result.fields.antiseptic.p1p2p3,

    result.fields.useCompresses.p1p2p3,
    result.fields.useCompresses.b1b2,
    result.fields.compressesType.p1p2p3,
    result.fields.compressesType.b1b2,
    ...result.fields.antiseptic.b1,
    ...result.fields.antiseptic.b2,
    result.fields.valve.b1b2,
    ...result.fields.valveAntiseptic.b1b2,
    result.fields.antisepticPassages.p1p2p3,
    result.fields.dry.p1p2p3,

    ...result.fields.handHygieneBeforeInsertion.p1,
    ...result.fields.handHygieneBeforePeriInsertion.p2,
    ...result.fields.handHygieneBeforePuncture.p3,

    result.fields.gloves.p1p2p3b1,
    result.fields.glovesType.p1p2p3b1,
    result.fields.glovesJustified.b1,
    result.fields.palpation.p2,

    ...result.fields.whyNCAuditedOutfit.p1p3,
    ...result.fields.whyNotAuditedMask.b2,
    ...result.fields.whyNCPatientOutfit.p3b2,
    ...result.fields.whyNotAlcool.p1p2p3,
    ...result.fields.whyNotHHC.p1,
    ...result.fields.whyNotHH.p2,
    ...result.fields.whyNotHHP.p3,
    ...result.fields.whyNotGloves.p2,
    ...result.fields.whyNotHHM.b1,
    ...result.fields.whyNotHHM.b2,
    ...result.fields.whyNotCompresses.b1,
    ...result.fields.whyNotSterileCompresses.b1,
    ...result.fields.whyNotDisinfectValve.b1b2
  ],

  buildNotes: function (resultNotes, sheet) {
    checkAge(
      resultNotes, sheet, {
        unitType: patient.unitType.v1.rw.field,
        isAdult: result.fields.isAdult.p1p2p3.field,
        childAge: result.fields.childAge.p1p2p3.field
      }
    )
    checkDate(
      resultNotes, sheet, '2021', {
        obsDate: result.fields.obsDate.all
      }
    )
    return resultNotes
  }
}

result.assertAllFieldsAreUsed('2021')
export default ice.freeze(result, 10)
